import { SimpleGenList } from '../simpleGenList';

/**
 * Parts of speech in Czech.
 * Port of C# Seznam_SlovniDruhy__CS.
 */
export class GenList_PartsOfSpeech__CS extends SimpleGenList {
  constructor() {
    super(
      'podstatná jména',
      'přídavná jména',
      'zájmena',
      'číslovky',
      'slovesa',
      'příslovce',
      'předložky',
      'spojky',
      'částice',
      'citoslovce'
    );
  }
}

/**
 * Parts of speech in Latin.
 * Port of C# Seznam_SlovniDruhy__LA.
 */
export class GenList_PartsOfSpeech__LA extends SimpleGenList {
  constructor() {
    super(
      'substantiva',
      'adjektiva',
      'pronomina',
      'numeralia',
      'verba',
      'adverbia',
      'prepozice',
      'konjunkce',
      'partikule',
      'interjekce'
    );
  }
}
